import { render, staticRenderFns } from "./BaseUploadImage.vue?vue&type=template&id=1ec2e654&scoped=true&"
import script from "./BaseUploadImage.vue?vue&type=script&lang=js&"
export * from "./BaseUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadImage.vue?vue&type=style&index=0&id=1ec2e654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2e654",
  null
  
)

export default component.exports